<template>
  <modal title="" width="35" :showModal="showModal" @close-modal="closeModal">
    <div class="px-6 mb-6">
      <div class="flex justify-center">
        <img
          src="@/assets/images/booking-management/shipping-cart.png"
          alt="shipping cart"
        />
      </div>
      <div class="flex justify-center my-3">
        <h1 class="text-2xl font-semibold">Multiple Consignees?</h1>
      </div>

      <div>
        <p class="label my-4">Do you want to add another Consignee?</p>
        <div class="flex items-center my-6">
          <div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9998 0C5.37259 0 0 5.37267 0 11.9999C0 18.6269 5.37251 24 11.9996 24C18.6268 24 23.9998 18.6269 23.9998 11.9999C23.9998 5.37267 18.6269 0 11.9998 0ZM17.0622 13.3199H13.2007V17.3574C13.2004 18.0345 12.6516 18.5833 11.9744 18.5833C11.297 18.5833 10.7482 18.0345 10.7482 17.357V13.3199H6.98945C6.31218 13.3197 5.76362 12.7709 5.76322 12.0937C5.76322 11.4167 6.31226 10.8677 6.98945 10.8675L10.7481 10.8677V7.28449C10.7481 6.60721 11.2972 6.05826 11.9742 6.05826C12.6516 6.05826 13.2007 6.60729 13.2004 7.28449L13.2007 10.8674L17.0618 10.8678C17.7391 10.8674 18.2883 11.4166 18.2881 12.094C18.2883 12.7713 17.7391 13.3199 17.0622 13.3199Z"
                fill="#E59506"
              />
            </svg>
          </div>
          <div>
            <p
              class="text-sm pl-2 underline cursor-pointer brand-gold"
              @click="addNewConsignee"
            >
              Add Another Consignee
            </p>
          </div>
        </div>
      </div>

      <div>
        <p>OR</p>
      </div>

      <div class="flex items-center my-6">
        <div>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.7958 11.4657L16.5962 3.46615C16.4426 3.29656 16.2282 3.20056 16.001 3.20056H11.2012C10.8861 3.20056 10.5997 3.38615 10.4701 3.67414C10.3421 3.96372 10.3949 4.3013 10.6061 4.53489L17.3241 12.0001L10.6061 19.4637C10.3949 19.6989 10.3405 20.0364 10.4701 20.3244C10.5997 20.614 10.8861 20.7996 11.2012 20.7996H16.001C16.2282 20.7996 16.4426 20.702 16.5962 20.5356L23.7958 12.5361C24.0694 12.2321 24.0694 11.7681 23.7958 11.4657Z"
              fill="#E59506"
            />
            <path
              d="M13.3954 11.4657L6.19576 3.46615C6.04217 3.29656 5.82778 3.20056 5.6006 3.20056H0.800856C0.485673 3.20056 0.199289 3.38615 0.0696959 3.67414C-0.0582972 3.96372 -0.00550007 4.3013 0.205688 4.53489L6.92372 12.0001L0.205688 19.4637C-0.00550007 19.6989 -0.0598971 20.0364 0.0696959 20.3244C0.199289 20.614 0.485673 20.7996 0.800856 20.7996H5.6006C5.82778 20.7996 6.04217 20.702 6.19576 20.5356L13.3954 12.5361C13.669 12.2321 13.669 11.7681 13.3954 11.4657Z"
              fill="#E59506"
            />
          </svg>
        </div>
        <div>
          <p
            class="text-sm pl-2 underline cursor-pointer brand-gold"
            @click="$emit('change-form')"
          >
            Proceed To make Payment
          </p>
        </div>
      </div>

      <div>
        <button class="button button-long mt-4">
          Continue
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      addresses: ["25 Admiralty way, Lekki Phase  1"],
      address: "",
      consigneeCount: "",
      destinationType: "",
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    addNewConsignee() {
      this.$store.dispatch("removeOldConsigneeData");
      this.$emit("add-new-consignee");
    },
  },
};
</script>

<style scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}
.brand-gold {
  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
